module.exports = __webpack_public_path__ + "static/img/basics_item.b8941861.png";